"use strict";

var _slicedToArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useSetState_1 = require("./useSetState");

var useMount_1 = require("./useMount");

var useSpeech = function useSpeech(text) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useSetState_1$defaul = useSetState_1.default({
    isPlaying: false,
    volume: opts.volume || 1
  }),
      _useSetState_1$defaul2 = _slicedToArray(_useSetState_1$defaul, 2),
      state = _useSetState_1$defaul2[0],
      setState = _useSetState_1$defaul2[1];

  var uterranceRef = react_1.useRef(null);
  useMount_1.default(function () {
    var utterance = new SpeechSynthesisUtterance(text);
    utterance.volume = opts.volume || 1;

    utterance.onstart = function () {
      return setState({
        isPlaying: true
      });
    };

    utterance.onresume = function () {
      return setState({
        isPlaying: true
      });
    };

    utterance.onend = function () {
      return setState({
        isPlaying: false
      });
    };

    utterance.onpause = function () {
      return setState({
        isPlaying: false
      });
    };

    uterranceRef.current = utterance;
    window.speechSynthesis.speak(uterranceRef.current);
  });
  return state;
};

exports.default = useSpeech;